// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Apply-Slot[data-v-1b9034cd] {\n  position: relative;\n}\n.Mask-True[data-v-1b9034cd] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.2;\n  z-index: 1008;\n}\n", ""]);
// Exports
module.exports = exports;
